import React from "react";
import "./Footer.css";

const Footer = () => {
  return <div className="footer">@2024 Phan Quoc Bao</div>;
};

export default Footer;
